(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8371],{

/***/ 55861:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auctions/inquiry",
      function () {
        return __webpack_require__(11819);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 11819:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "__N_SSG": function() { return /* binding */ __N_SSG; },
  "default": function() { return /* binding */ AuctionInquiry; }
});

// EXTERNAL MODULE: ../../node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(94776);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ../../node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(52322);
// EXTERNAL MODULE: ../../node_modules/react/index.js
var react = __webpack_require__(2784);
// EXTERNAL MODULE: ../../node_modules/tailwind-styled-components/dist/index.js
var dist = __webpack_require__(17471);
var dist_default = /*#__PURE__*/__webpack_require__.n(dist);
// EXTERNAL MODULE: ../../node_modules/next-i18next/dist/esm/index.js + 11 modules
var esm = __webpack_require__(33052);
// EXTERNAL MODULE: ../../node_modules/react-hook-form/dist/index.esm.mjs
var index_esm = __webpack_require__(63955);
// EXTERNAL MODULE: ../core/src/components/Card.tsx
var Card = __webpack_require__(28658);
// EXTERNAL MODULE: ../core/src/components/Navigation/NavBar.tsx + 7 modules
var NavBar = __webpack_require__(42234);
// EXTERNAL MODULE: ../core/src/components/Forms/Form.tsx
var Form = __webpack_require__(48375);
// EXTERNAL MODULE: ../core/src/components/BackgroundImage.tsx
var BackgroundImage = __webpack_require__(59645);
// EXTERNAL MODULE: ../core/src/components/Inputs/CheckBox.tsx
var CheckBox = __webpack_require__(76008);
// EXTERNAL MODULE: ../core/src/components/ErrorMessages.tsx
var ErrorMessages = __webpack_require__(29371);
// EXTERNAL MODULE: ../core/src/components/Inputs/TextInput.tsx
var TextInput = __webpack_require__(10809);
// EXTERNAL MODULE: ../core/src/components/Button.tsx
var Button = __webpack_require__(36573);
// EXTERNAL MODULE: ../core/src/components/Navigation/FooterLanding.tsx + 5 modules
var FooterLanding = __webpack_require__(56993);
// EXTERNAL MODULE: ../core/src/components/Modal.tsx
var Modal = __webpack_require__(27581);
// EXTERNAL MODULE: ../graphql/src/generated/index.ts + 11 modules
var generated = __webpack_require__(63575);
;// CONCATENATED MODULE: ../assets/images/filtered-forest.png
/* harmony default export */ var filtered_forest = ({"src":"/_next/static/media/filtered-forest.21aee6e3.png","height":3255,"width":4320,"blurDataURL":"data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAgAAAAGCAMAAADJ2y/JAAAAD1BMVEUINkIkVF4aSlMSQko0XWFnBzKpAAAACXBIWXMAACE4AAAhOAFFljFgAAAAI0lEQVQImWXGsREAMBDCMLDZf+bc11Gl0LMGr1uA7qKCmM8DCZoASJB8rGgAAAAASUVORK5CYII="});
// EXTERNAL MODULE: ../core/src/utils/index.ts
var utils = __webpack_require__(75920);
;// CONCATENATED MODULE: ./src/pages/auctions/inquiry.tsx










function _arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _arrayWithHoles(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _defineProperty(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterableToArrayLimit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _defineProperty(target, key, source[key]);
        });
    }
    return target;
}
function _slicedToArray(arr, i) {
    return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _taggedTemplateLiteral(strings, raw) {
    if (!raw) {
        raw = strings.slice(0);
    }
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}
function _unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _templateObject() {
    var data = _taggedTemplateLiteral([
        "container py-16 flex flex-col items-center"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = _taggedTemplateLiteral([
        "\n  text-white\n  text-3xl\n  font-bold\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = _taggedTemplateLiteral([
        "shadow flex-1 space-y-4 self-stretch md:self-center min-w-[50%]"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
var Container = dist_default().div(_templateObject());
var Title = dist_default().p(_templateObject1());
var CenteredCard = dist_default()(Card/* Card */.Z)(_templateObject2());
var __N_SSG = true;
function AuctionInquiry() {
    var ref2 = (0,react.useState)(false), modalOpen = ref2[0], setModalOpen = ref2[1];
    var ref1 = _slicedToArray((0,generated/* useCreateStartAuctionInquiryMutation */.PWb)(), 1), createStartAuctionInquiryMutation = ref1[0];
    var t = (0,esm/* useTranslation */.$G)([
        'inquiries',
        'common',
        'enum'
    ]).t;
    var form = (0,index_esm/* useForm */.cI)();
    var register = form.register, setError = form.setError, setValue = form.setValue, watch = form.watch, formState = form.formState, clearErrors = form.clearErrors;
    var onSubmit = (0,react.useCallback)(function() {
        var _ref = _asyncToGenerator(runtime_default().mark(function _callee(input) {
            var ref, data, error;
            return runtime_default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        ;
                        if (input.intent) {
                            _ctx.next = 3;
                            break;
                        }
                        return _ctx.abrupt("return", setError('intent', {
                            message: t('auction.mustChoose')
                        }));
                    case 3:
                        _ctx.next = 5;
                        return createStartAuctionInquiryMutation({
                            variables: {
                                input: input
                            }
                        });
                    case 5:
                        data = _ctx.sent.data;
                        error = data === null || data === void 0 ? void 0 : (ref = data.createStartAuctionInquiry) === null || ref === void 0 ? void 0 : ref.error;
                        if (error) {
                            if (error.email) {
                                setError('email', (0,utils/* getErrorTranslations */.Hm)('StartAuctionInquiryEmailError', error.email));
                            }
                            if (error.phoneNumber) {
                                setError('phoneNumber', (0,utils/* getErrorTranslations */.Hm)('StartAuctionInquiryPhoneNumberError', error.phoneNumber));
                            }
                        } else {
                            setModalOpen(true);
                        }
                    case 8:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }));
        return function(input) {
            return _ref.apply(this, arguments);
        };
    }(), [
        createStartAuctionInquiryMutation,
        setError,
        t
    ]);
    var closeModal = (0,react.useCallback)(function() {
        return setModalOpen(false);
    }, []);
    var setIntent = (0,react.useCallback)(function(param) {
        var target = param.target;
        clearErrors('intent');
        setValue('intent', target.value);
    }, [
        clearErrors,
        setValue
    ]);
    var intent = watch('intent');
    return(/*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("main", {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(NavBar/* NavBar */.l, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Form/* Form */.l, _objectSpread({}, form, {
                        onSubmit: onSubmit,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                className: "z-[-1] absolute left-0 right-0 bottom-0 top-0",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(BackgroundImage/* BackgroundImage */.X, {
                                    src: filtered_forest,
                                    priority: true
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container, {
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Title, {
                                        className: "mb-4 md:mb-8",
                                        children: t('auction.title')
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(CenteredCard, {
                                        children: [
                                            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                className: "flex flex-col space-y-2",
                                                children: [
                                                    /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                                                        className: "flex justify-around",
                                                        children: [
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                                                                label: t("enum:AuctionSalePurpose.forest_with_land"),
                                                                name: "intentWithLand",
                                                                value: generated/* StartAuctionIntent.WithLand */.VSp.WithLand,
                                                                onChange: setIntent,
                                                                checked: intent === generated/* StartAuctionIntent.WithLand */.VSp.WithLand
                                                            }),
                                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CheckBox/* CheckBox */.J, {
                                                                label: t("enum:AuctionSalePurpose.forest_for_harvesting"),
                                                                name: "intentForHarvesting",
                                                                value: generated/* StartAuctionIntent.ForCutting */.VSp.ForCutting,
                                                                onChange: setIntent,
                                                                checked: intent === generated/* StartAuctionIntent.ForCutting */.VSp.ForCutting
                                                            })
                                                        ]
                                                    }),
                                                    /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                                                        className: "flex justify-center",
                                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ErrorMessages/* ErrorMessages */.X, {
                                                            error: formState.errors.intent
                                                        })
                                                    })
                                                ]
                                            }),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('common:email')
                                            }, register('email', {
                                                required: true
                                            }))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('common:phoneNumber')
                                            }, register('phoneNumber', {
                                                required: true
                                            }))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(TextInput/* TextInput */.o, _objectSpread({
                                                label: t('common:enterCadastralNumber')
                                            }, register('cadastralNumber'))),
                                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                                                title: t('common:continue'),
                                                value: "auction-inquiry-submit"
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    }))
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(FooterLanding/* FooterLanding */.m, {}),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Modal/* Modal */.u, {
                    open: modalOpen,
                    onClose: closeModal,
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("p", {
                            className: "text-3xl mb-8",
                            children: t('auction.received')
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* Button */.z, {
                            title: t('common:continue'),
                            value: "auction-inquiry-received",
                            onClick: closeModal
                        })
                    ]
                })
            ]
        })
    }));
};


/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [7362,1433,3442,2234,9659,9774,2888,179], function() { return __webpack_exec__(55861); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);